<template>
    <div v-show="!match.onLive">
        <template v-if="odd.id == 888">
            <div class="OddsRow-styles-odds-row Category-styles-event-details-row">
                <div class="OddsRow-styles-info-cell  OddsRow-styles-w50">
                    <span class="notranslate MarketName" >{{ odd.bundle[0].n.replace('{%player}', '') }}</span>
                </div>
                <div class="OddsRow-styles-odd-group-cell">
                    <div class="OddResult-styles-odd-desc">
                        1
                    </div>
                    <div class="OddResult-styles-odd-desc">
                        X
                    </div>
                    <div class="OddResult-styles-odd-desc">
                        2
                    </div>
                </div>
            </div>

            <div class="OddsRow-styles-odds-row Category-styles-event-details-row" v-for="v in odd.bundle">
                <div class="OddsRow-styles-info-cell  OddsRow-styles-w50">
                    <span class="notranslate">👤 {{ v.seq }} </span>
                </div>
                <div class="OddsRow-styles-odd-group-cell">
                <SelectionButton mode="1" v-show="!selection.outcome.match('other')" v-for="selection in sortAByKey(v.odd, 'order')"
                            :selectedOdds="selectedOdds" :odd.sync="selection" :match="match" :market="v">
                </SelectionButton>
                </div>
            </div>
        </template>
        <template v-if="odd.id == 38">
            <div class="OddsRow-styles-odds-row Category-styles-event-details-row">
                <div class="OddsRow-styles-info-cell  OddsRow-styles-w50">
                    <span class="notranslate MarketName" >Goal Scorrer</span>
                </div>
                <div class="OddsRow-styles-odd-group-cell">
                    <div class="OddResult-styles-odd-desc">
                        First
                    </div>
                    <div class="OddResult-styles-odd-desc">
                        Last
                    </div>
                    <div class="OddResult-styles-odd-desc">
                        Any
                    </div>
                </div>
            </div>
        </template>
        <template v-if="odd.id == 38">
            <div class="row">
                    <div class="col-6">
                        <div class="OddsRow-styles-odds-row p-2" v-for="(vc,i) in odd.bundle.outcomes">
                            👤 {{ vc | slimiter(20) }}
                        </div>
                    </div>
                    <div class="col-2 p-0 m-0" v-for="b in sortAByKey(odd.bundle.list, 'order')">
                        <div class="OddsRow-styles-odd-group-cell mb-1" v-for="odd in b.odd" v-show="!odd.outcome.match('N goal')">
                            <SelectionButton mode="1" 
                                            :selectedOdds="selectedOdds" :odd.sync="odd" :match="match" :market="b">
                            </SelectionButton>
                        </div>
                    </div>
                </div>

        </template>
    </div>
</template>

<script>
    import SelectionButton from "../../selectionButton";
    export default {
        name: 'bundle',
        props: ['odd' , 'match', 'selectedOdds'],
        components: {SelectionButton},
        data () {
            return {
                playerMarket: []
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.OddResult-styles-odd-desc {
    flex: 1;
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
    min-height: 100%;
    text-align: center !important;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/market/template/bundle.vue